export default {"src":"/_next/static/media/ic-help.529c95ad.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};